document.documentElement.className = ''; //Remove no-js class

// called in currencies-switcher.liquid
function updateCurrency(selector){
  $(selector).parents('form').submit();
}

//change search bar to white on focus
$(function(){
  $('[name="q"]').on('focus',function(){$(this).closest('.searchnavwrap').css({'background':'white','color':'black'});}).on('blur focusout',function(){$(this).closest('.searchnavwrap').removeAttr('style');});
});

//Search box, add focus class to wrapper
$(document).on('focusin focusout','.panelinputblock .panelinputinner input.text', function(e){
  $(this).closest('.panelinputblock').toggleClass('focus', e.type == 'focusin');
});



$(document).ready(setActiveMenuItem)
function setActiveMenuItem(){
  var currentPagePath = "{{ shop.url }}{{ request.path }}"
  var listItems = $("#mainMenuList li");
  listItems.each(function(index) {
    if($(this).children().prop('href') == currentPagePath){
      $(this).addClass("mainNavActive")
    }
  });
}

// when the main gallery image is clicked it shows a big image
function showLightbox(mainImage){
  var mainImageIndex = parseInt(mainImage.getAttribute('data-index'), 10)
  console.log(mainImageIndex);
  var images = [];
  var thumbs = document.getElementsByClassName('gallery-img')
  if (thumbs.length == 0){ //if the main image is the only image
    $.fancybox.open(mainImage)
    return;
  }
  for (var image of thumbs)
  images.push({src: image.getAttribute('data-master'), opts: {thumb: image.getAttribute('src')} })
  $.fancybox.open(images, {}, mainImageIndex)


  
}







//Function to show a quick generic text popup above an element
window.showQuickPopup = function(message, $origin){
  var $popup = $('<div>').addClass('simple-popup hidden');
  var offs = $origin.offset();
  $('body').append($popup);
  $popup.html(message).css({ 'left':offs.left - ($popup.outerWidth() - $origin.outerWidth()), 'top':offs.top });
  $popup.css('margin-top', - $popup.outerHeight() - 10).removeClass('hidden');
  setTimeout(function(){
    $popup.addClass('hidden');
    setTimeout(function(){
      $popup.remove();
    }, 500);
  }, 4000);
};

$('#reveal-header').on('click', function(){
  $('body').toggleClass('reveal-header');
  setTimeout(function(){
    //Things to change after altering the content size
    //remasonry();
    $(window).trigger('debouncedresize');
  }, 501);
  return false;
});


$(function($){



  //
  // if(Modernizr.input.placeholder){
  //   //Placeholder text will vanish upon focus
  //   $('input[placeholder]').each(function(){
  //     $(this).data('placeholder', $(this).attr('placeholder'));
  //   });
  //   $(document).on('focusin', 'input[placeholder]', function(){
  //     $(this).attr('placeholder', '');
  //   }).on('focusout', 'input[placeholder]', function(){
  //     if($(this).val() == '' && typeof($(this).data('placeholder')) != 'undefined') {
  //       $(this).attr('placeholder', $(this).data('placeholder'));
  //     }
  //   });
  // } else {
  //   //Simulate placeholder with JS
  //   $(document).on('focusin', 'input[placeholder]', function(){
  //     $(this).val('');
  //   }).on('focusout', 'input[placeholder]', function(){
  //     if($(this).val() == '' && typeof($(this).attr('placeholder')) != 'undefined') {
  //       $(this).val($(this).attr('placeholder'));
  //     }
  //   });
  //   $('input[placeholder]').trigger('focusout');
  //   $('input[placeholder]').parents('form').submit(function() {
  //     $(this).find('input[placeholder]').each(function() {
  //       var $input = $(this);
  //       if ($input.val() == $input.attr('placeholder')) {
  //         $input.val('');
  //       }
  //     });
  //   });
  // }

  // Simple button to expand/contract a div - also toggles text from show/hide
  $(document).on('click', '.togglebutton', function(){
    $btn = $(this);

    // Close any other buttons within group first
    if($btn.is('[data-exclusive-group]')) {
      $('[data-exclusive-group="'+$btn.data('exclusive-group')+'"]:not([data-target="'+$btn.data('target')+'"])').each(function(){
        $($(this).data('target')).slideUp();
        $(this).trigger('eval-toggle');
      });
    }

    $($(this).data('target')).slideToggle($(this).data('speed'), function(){
      $btn.trigger('eval-toggle');

      //Reload masonry if within it
      $(this).closest('.blocklayout').each(function(){
        remasonry();
      });
    });
    return false;
  }).on('eval-toggle', '.togglebutton[data-text-hide]', function(){
    $tar = $($(this).data('target'));
    //Show/hide text
    if($tar.is(':visible')) {
      $(this).toggleClass('expanded', true).html($(this).data('text-hide'));
    } else {
      $(this).toggleClass('expanded', false).html($(this).data('text-show'));
    }
  });

  //Redirect dropdowns
  // $(document).on('change', 'select.navdrop', function(){
  //   window.location = $(this).val();
  // });

});


function addToCartSuccess(){
  //Added, show message & update cart display
  window.showQuickPopup('Added to Cart!', $('#add-to-cart, #addToCartButton'));
  updateCartItemsCount();
}

function addToCartFail(data){
  if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
    var jsonRes = $.parseJSON(data.responseText);
    window.showQuickPopup(jsonRes.description, $('#add-to-cart'));
  }
}

function updateCartItemsCount(){
  $.get('/search', function(data){
    var $newCartObj = $(data).find('#navpanel .cartsummary');
    var $currCart = $('#navpanel .cartsummary');
    if ($currCart.length == 0) $('#shoplogo').after($newCartObj);
    else $currCart.html($newCartObj.html());
  });
}
